import { ABIIconButton, PowerIcon } from '@ab-inbev-labs/ux-react-components';
import { useMsal } from '@ab-inbev/sam-auth';
import { FC } from 'react';

export const LogoutButton: FC = () => {
  const { instance: msalInstance } = useMsal();

  const handleLogout = () => {
    msalInstance
      .logoutRedirect({
        postLogoutRedirectUri: `${window.location.origin}/apps`
      })
      .catch((error) => {
        // Handle logout error
        console.error('Error during user initiated logout: ', error);
      });
  };

  return (
    <ABIIconButton className="logout-button" data-testid="logout-button" onClick={handleLogout}>
      <PowerIcon color="var(--color-action-default)" height={18} width={18} />
    </ABIIconButton>
  );
};
